import type { CommandAction, CommandArgSpec, CommandAvailability, CommandResult } from "./commands.types";

export const READY: CommandAvailability = { status: "ready" };
export const HIDDEN: CommandAvailability = { status: "hidden" };
/** Shown but not built yet: the palette row is disabled, with a SoonBadge and the shared soon tooltip. */
export const SOON: CommandAvailability = { status: "soon" };

/** Story commands that read data or change the story. The read-only viewer shows them as Coming soon. */
export const VIEWER_SOON_COMMAND_IDS: ReadonlySet<string> = new Set([
  "story.viewSql", "story.viewData", "story.editChart", "story.addChart", "story.openComments",
  "story.deleteChart", "story.duplicateChart", "story.addFilter",
]);

/** In viewer mode, reports the data-reading and editing story commands as soon (disabled, never ready or hidden). Otherwise returns the actions untouched. */
export const soonInViewer = (actions: CommandAction[], isViewer: boolean): CommandAction[] =>
  isViewer ? actions.map((action) => (VIEWER_SOON_COMMAND_IDS.has(action.id) ? { ...action, isAvailable: () => SOON } : action)) : actions;

export const couldntRun = (label: string): CommandResult => ({ status: "failed", message: `Couldn't run ${label}.` });

/** A required or optional entity argument whose options are read on every use. */
export const entityArg = (
  name: string, entity: string, description: string, options: () => { id: string; label: string }[], required = true,
): CommandArgSpec => ({ name, description, required, kind: "entity", entity, options });
